import { UseMutationResult, useQueryClient } from "@tanstack/react-query"
import { MedicalInfoQueryKey } from "../context/MedicalInfoContext"
import { useHistory } from "react-router-dom"
import {
  ROUTING_INFO_QUERY_KEY,
  useStartCheckInExperienceRoutingInfo,
  useStartJourneyChangeRoutingInfo,
  useStartRenewalRoutingInfo
} from "./useQueryRoutingInfo"
import { ROUTING_STATUS_QUERY_KEY } from "#/components/carrot-plans/hooks/useGetInProgressCarrotPlanRequestType"
import { CarrotPlansPaths } from "#/utils/Paths"
import { RoutingFlowType } from "#/components/carrot-plans/types/routingFlowType"

type StartRoutingParams = {
  mutateFn: () => UseMutationResult
  url: CarrotPlansPaths
}

const startRoutingParamMap: Record<RoutingFlowType, StartRoutingParams> = {
  [RoutingFlowType.CASE_RATE_RENEWAL]: {
    mutateFn: useStartRenewalRoutingInfo,
    url: CarrotPlansPaths.CASE_RATE_RENEWAL_REFRESH_REQUEST
  },
  [RoutingFlowType.CHECK_IN_EXPERIENCE]: {
    mutateFn: useStartCheckInExperienceRoutingInfo,
    url: CarrotPlansPaths.CHECK_IN_EXPERIENCE
  },
  [RoutingFlowType.JOURNEY_CHANGE]: {
    mutateFn: useStartJourneyChangeRoutingInfo,
    url: CarrotPlansPaths.JOURNEY_CHANGE
  }
}

export function useStartRouting(flow: RoutingFlowType) {
  const { mutate } = startRoutingParamMap[flow].mutateFn()
  const queryClient = useQueryClient()
  const history = useHistory()

  async function startRouting() {
    mutate(null, {
      onSuccess: async () => {
        // Remove these query from the cache
        queryClient.removeQueries([MedicalInfoQueryKey])
        // Refetch so that we are sure to get null back for medical since we are starting routing over
        await queryClient.prefetchQuery([ROUTING_INFO_QUERY_KEY])
        await queryClient.refetchQueries([MedicalInfoQueryKey])
        await queryClient.refetchQueries([ROUTING_STATUS_QUERY_KEY])
        history.push(startRoutingParamMap[flow].url)
      }
    })
  }

  return { startRouting }
}
